import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import ListItemButton from '@mui/material/ListItemButton';
import MenuList from '@mui/material/MenuList';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

export const PickerTriggerButton = styled(Button)(({ theme }) => ({
  height: 34,
  borderRadius: 10,
  paddingLeft: 14,
  paddingRight: 14,
  fontSize: '0.75rem',
  fontWeight: 600,
  textTransform: 'none',
  letterSpacing: 0,
  color: theme.palette.primary.dark,
  backgroundColor: '#fff',
  boxShadow: '0 2px 8px rgba(47, 39, 117, 0.18)',
  gap: 6,
  '&:hover': {
    backgroundColor: 'rgba(255,255,255,0.93)',
    boxShadow: '0 4px 16px rgba(47, 39, 117, 0.24)',
  },
  '& .MuiButton-startIcon': {
    marginRight: 0,
    marginLeft: 0,
  },
  '& .MuiButton-startIcon > svg': {
    width: 15,
    height: 15,
  },
}));

export const PickerPopper = styled(Popper)({
  zIndex: 1300,
  width: 280,
});

export const PickerPaper = styled(Paper)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 16,
  boxShadow: '0 20px 60px rgba(15, 23, 42, 0.14), 0 4px 16px rgba(15, 23, 42, 0.08)',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
}));

export const SearchBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
  borderBottom: `1px solid ${theme.palette.divider}`,
  '& .MuiOutlinedInput-root': {
    borderRadius: 10,
    fontSize: '0.8125rem',
    backgroundColor: theme.palette.action.hover,
    '& fieldset': { border: 'none' },
  },
  '& .MuiInputBase-input': {
    paddingTop: 6,
    paddingBottom: 6,
  },
}));

export const SectionLabelBox = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(0.5),
}));

export const SectionLabel = styled(Typography)(({ theme }) => ({
  fontSize: '0.5625rem',
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  color: theme.palette.text.disabled,
}));

export const LoadingBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  padding: theme.spacing(2),
}));

export const EmptyText = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(1.5),
  textAlign: 'center',
  fontSize: '0.8125rem',
  color: theme.palette.text.secondary,
}));

export const MemberMenuList = styled(MenuList)({
  maxHeight: 220,
  overflowY: 'auto',
  padding: '4px 0 6px',
  '&::-webkit-scrollbar': { width: 4 },
  '&::-webkit-scrollbar-track': { background: 'transparent' },
  '&::-webkit-scrollbar-thumb': { background: 'rgba(0,0,0,0.12)', borderRadius: 4 },
});

export const MemberMenuItem = styled(ListItemButton)(({ theme }) => ({
  gap: theme.spacing(1),
  paddingTop: 6,
  paddingBottom: 6,
  paddingLeft: theme.spacing(1.25),
  paddingRight: theme.spacing(1.25),
  margin: '0 6px',
  borderRadius: 10,
  '&:hover': {
    backgroundColor: 'rgba(110, 79, 247, 0.06)',
  },
  '&.Mui-selected': {
    backgroundColor: 'rgba(110, 79, 247, 0.08)',
    '&:hover': { backgroundColor: 'rgba(110, 79, 247, 0.12)' },
  },
}));

export const PendingSpinner = styled(CircularProgress)({
  flexShrink: 0,
  width: '18px !important',
  height: '18px !important',
});

export const MemberAvatar = styled(Avatar)({
  width: 28,
  height: 28,
  fontSize: 12,
  fontWeight: 600,
  flexShrink: 0,
});

export const MemberInfoBox = styled(Box)({
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
});

export const CheckmarkBox = styled(Box)<{ checked: boolean }>(({ checked, theme }) => ({
  width: 16,
  height: 16,
  borderRadius: 5,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: checked
    ? `2px solid ${theme.palette.primary.main}`
    : `2px solid ${theme.palette.divider}`,
  backgroundColor: checked ? theme.palette.primary.main : 'transparent',
  transition: 'all 0.15s ease',
  marginLeft: 'auto',
}));
